import { useTranslation } from 'react-i18next';
import type { IncidentOwnerTag } from '@/app/components/incident-overview/utils/incident-landlord.utils';

type Props = {
  tag: IncidentOwnerTag;
};

export function IncidentOwnerTagBadge({ tag }: Props) {
  const { t } = useTranslation('incidents');

  return (
    <span
      className={`incident-table-row-controls__owner-tag incident-table-row-controls__owner-tag--${tag.kind}`}
      title={
        tag.kind === 'operator'
          ? t('overview.table.operatorOwnerHint', 'Operator-owned asset')
          : t('overview.table.landlordOwnerHint', {
              name: tag.label,
              defaultValue: 'Landlord: {{name}}',
            })
      }
    >
      {tag.kind === 'operator'
        ? t('overview.table.operatorOwner', 'Operator')
        : tag.label}
    </span>
  );
}
